import { toNumberLookup } from "@/utils/groupBy"
import { timeFromString } from "@/utils/time"
import { AloAccompagnement } from "./AloAccompagnement"
import { AloAllergene } from "./AloAllergene"
import { AloArbo } from "./AloArbo"
import { AloBase, getDefaultAloBase } from "./AloBase"
import { AloPanier } from "./AloPanier"
import { AloPanStatusHisto } from "./AloPanStatusHisto"
import { AloSejour } from "./AloSejour"
import { IItemPanier, ItemPanier } from "./ItemPanier"


export interface AloCommande extends AloBase {
                    
    panDatlivraison: string
    panDatadd: string
    panValide: boolean    
    panMontant: number|null   
    panStatus: number|null
    panCommentaire: string
    panJson: string
    sejour:AloSejour|null
    histosStatus:Array<AloPanStatusHisto>
    panier:AloPanier
    mtpId:number|null
    type:string
    timer:number|null
    panLg:string
    panUiid:string
    tempsPreparation:number
}

export const getDefaultAloCommande = ():AloCommande => {
    return {  
        ...getDefaultAloBase(),        
        panDatlivraison: "",
        panDatadd:"",
        panValide : true,        
        panMontant:null,
        panStatus:null,
        panCommentaire:"",
        panJson:"",        
        sejour:null,
        histosStatus:[],
        panier:new AloPanier(),
        mtpId:null,
        type:"mdi-silverware",
        timer:null,
        panLg:"fr",
        panUiid:"",
        tempsPreparation:30
    }
}

export const cleanAloCommande = (commande:AloCommande) => {
    if(!commande) return    
    if(!commande.id) delete commande.id
    if(!commande.panStatus) delete commande.panStatus               
    if(!commande.mtpId) delete commande.mtpId
    
    //Mise à jour des champs de la commande en fonction du panier
    commande.panDatlivraison = commande.panier.heureLivraison
    commande.tempsPreparation = commande.panier.tempsPreparation
    commande.panMontant = commande.panier.prixTotalAvecOptions
    commande.panJson = JSON.stringify(commande.panier)    
    

    delete commande.panier    
}

